import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Popular Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Browse our curated product categories — each spreadsheet link takes you directly to the latest finds on kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 rounded-lg overflow-hidden hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Sugargoo Spreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="flex items-center gap-2.5 px-3 py-3">
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Categories on kaspreadsheet.com
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}